import { dhlIconsStyles } from '@dhl-ui/icons'
import { dhlIllustrationStyles } from '@dhl-ui/illustrations'
import type { ThemeOption, Tokens } from '../augmentation'

export const createMuiCssbaseline = ({
  palette,
  fontSize,
  userSelect,
  disablePtr,
}: Pick<Tokens, 'palette'> & {
  fontSize: number
} & Pick<ThemeOption, 'userSelect' | 'disablePtr'>) => ({
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        height: '100%',
        // our basic font size, since we work with `rem` everything is relational to this value.
        fontSize: `${fontSize}px`,
        colorScheme: palette.mode === 'dark' ? 'dark' : 'light',
      },
      body: {
        height: '100%',
        WebkitFontSmoothing: 'antialiased',
        fontSize: '1rem',
        userSelect: userSelect || 'inherit',
        scrollBehavior: 'smooth',

        // we allow with usePageBackground to have some pages totally in white
        backgroundColor: 'background.paper',

        '@media print': {
          height: 'auto',
        },
      },

      ...(disablePtr && { 'html, body': { overscrollBehavior: 'none' } }),

      '#root': {
        height: '100%',
        // This has been done to give native apps the feeling after they scroll to bottom it still animates
        // FIXME: lets see if we add option for it or activate when disablePtr is on or ..
        overflowY: disablePtr ? 'auto' : undefined,
      },

      // https://mui.com/material-ui/react-text-field/#performance
      '@keyframes mui-auto-fill': { from: { display: 'block' } },
      '@keyframes mui-auto-fill-cancel': { from: { display: 'block' } },

      ...dhlIconsStyles,
      ...dhlIllustrationStyles,
    },
  },
})
